/* ================================================================
 * Copyright © 2025 Tobeunicorn Co., Ltd. All rights reserved.
 *
 * 프로젝트명 : ArmyLink V1.0
 * 설명 : 홍보 결과 목록 다이얼로그
 * 버전 : 1.0
 * 파일명 : PromoResultDialog.tsx
 * 작성자 : 강동형
 * 작성일 : 2025-03-01
 * ================================================================ 
 * 수정 : 2025-07-16, 강동형 : 저작권 추가, 기획 변경에 따른 변경
 *================================================================
 */

import React, { useEffect } from 'react'
import { Dialog, SlideProps, Slide } from '@mui/material';
import { useDialogStore } from 'src/stores/DialogStore';

// 모달창 슬라이드 트랜지션 스타일
const Transition = React.forwardRef(function Transition(
props: SlideProps,
ref: React.Ref<unknown>
) {
return <Slide direction="up" ref={ref} {...props} timeout={500} />;
});

//로직 영역
const PromoResultDialog = () => {
  const isOpen = useDialogStore((state)=>state.isOpen)
  const setOpen = useDialogStore((state)=>state.setOpen)
  const element = useDialogStore((state)=>state.element)
  const setField = useDialogStore((state)=>state.setField)

  useEffect(()=>{
    if(isOpen === false){
      setField('elementValue','')
    }
  },[isOpen])

  return (
    <Dialog
        open={isOpen}
        onClose={()=>setOpen(false)}
        fullWidth
        TransitionComponent={Transition}
        PaperProps={{
          sx: {
            position: 'fixed',
            bottom: 0,
            margin: 0,
            width: '100vw',
            height: 'auto',
            borderTopLeftRadius: 16,
            borderTopRightRadius: 16,
          }
        }}
      >
        {element}
      </Dialog>
  )
}

export default PromoResultDialog